import PopupRedesigned from './PopupRedesigned'

import { useState } from 'react'

import ActiveChatMessageView from '../ChatMessenger/ActiveChatMessageView'
import ChatMessengerControls from '../ChatMessenger/ChatMessengerControls'
import useHasFeature, { AppFeatures, AppSubFeatures } from 'hooks/useHasFeature'
import AISummary from 'widgets/AISummary'
import { AISummaryType } from 'hooks/useGetAISummary'
import useContact from 'hooks/redux/useContact'

interface Props {
    onClose: () => void
}

const Popup = ({ onClose }: Props) => {
    const [popupChildrenHeight, setPopupChildrenHeight] = useState(0)

    const contact = useContact()
    const hasFeature = useHasFeature()
    
    const hasAICatchupSummary = hasFeature(AppFeatures.AI_FEATURES, AppSubFeatures.AI_ACTION_FLOWS_PRE_CONTACT_SUMMARIES_CHAT)

    const getPopupHeight = (height: number) => {
        setPopupChildrenHeight(height)
    }

    const handleClose = () => {
        onClose()
    }

    return (
        <PopupRedesigned subject="Chat" onClose={handleClose} getHeight={getPopupHeight}>
            {hasAICatchupSummary && (
                <div className='sa-chat-ai-summary'>
                    <AISummary
                        contact={contact}
                        title="Catchup"
                        type={AISummaryType.PRE_CONTACT_CHAT}
                    />
                </div>
            )}
            <ActiveChatMessageView isExpanded />
            <ChatMessengerControls isExpanded/>
        </PopupRedesigned>
    )
}

export default Popup
